import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
// @material-ui/core components
import { DynamicTable, Button } from "@intervan-ar/ov-componentes";
import extendedFormsStyle from "../../components/Form/FormsStyle";

// @material-ui/icons
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import pagesStyle from "../../components/Page/PageStyle";
import tooltip from "../../components/Tooltip/TooltipStyle";
import { getScreenType } from '../../core/services/infoScreen.js';
import { Search } from '@material-ui/icons';

const styles = (theme) => ({
	...pagesStyle(theme),
	...extendedFormsStyle,
	...tooltip,
});

const ListadoPagos = (props) =>  {
  const [showAll, setShowAll] = useState(true);

	const toggleShowAll = () => {
		const bigScreen = getScreenType() !== 'sm';
		if (bigScreen !== showAll) setShowAll(bigScreen);
	};

  useEffect(() => {
    const interval = setInterval(toggleShowAll, 600);
    return () => {
      clearInterval(interval);
    };
  }, []);

	const onDownloadClick = (item) => {
		props.download(item.id_operacion);
	};

	const defaultFilter = (filter, row, column) => {
		const id = filter.pivotId || filter.id;
		return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true;
  };

	const renderPageJump = (options) => {
		return (
			<input
				style={{maxWidth:'60px'}}
				type="text"
				value={options.value}
				onBlur={options.onBlur}
				onChange={options.onChange}
				onKeyPress={options.onKeyPress}
			/>
		);
	};

  const tablePagos = {
    columns: [
			{
				header: "Transacción",
				accessor: "id_operacion",
        minWidth: 11,
				show: showAll,
				sortMethod: "(a, b) => { return Number(a) > Number(b) ? 1 : -1;}",
				filter: "Filtrar..."
			},
			{
				header: "Fecha",
				accessor: "fecha",
        minWidth: 11,
				show: showAll,
        cellContent: "new Date(row.value).getDate() + '/' + (new Date(row.value).getMonth() + 1) + '/' + new Date(row.value).getFullYear()",
				sortMethod: "(a, b) => { return new Date(a) > new Date(b) ? 1 : -1;}",
				filter: "Filtrar..."
			},
			{
				header: "Medio Pago",
        minWidth: 11,
				accessor: "desc_medio_pago",
				sortMethod: "(a, b) => { return String(a) > String(b) ? 1 : -1;}",
				filter: "Filtrar..."
			},
			{
				header: "Importe",
				accessor: "importe",
        minWidth: 11,
        style: { textAlign: 'right' },
        cellContent: "Intl.NumberFormat('de-AR', {style:'decimal', minimumFractionDigits:2 }).format(row.value);",
				sortMethod: "(a, b) => { return String(a) > String(b) ? 1 : -1;}",
				filter: "Filtrar..."
			},
		],
    filterable:true,
    resizable:true,
    defaultPageSize:10,
    showPaginationTop:false,
    showPaginationBottom:true,
    className:"-striped -highlight",
    previousText:"<",
    nextText:">",
    loadingText:"Cargando...",
    noDataText:"No se encontraron datos",
    pageText:"Página",
    ofText:"de",
    rowsText:"filas",
    toolbarOptions: {
      showToolbar: false
    },
    showFilters: false,
    defaultSorted: [
      {
        id   : 'fecha_1vto',
        desc : true,
      }]
  };

  const tableActions = (row, rowIndex) => {
    const actionList = [
      (
        <Button
          simple
          round
          size="sm"
          color="info"
          key={`ver-comprobante-${rowIndex}`}
          onClick={() => props.onClickVerComprobante(row.comprobante)}
        >
          <Search/>
        </Button>
      ),
      (
        <Button
          justIcon
          round
          simple
          key={`descargar-${rowIndex}`}
          onClick={() => onDownloadClick(row)}
          className="download"
          color="primary"
        >
          <CloudDownloadIcon/>
        </Button>
      )
    ];
    return actionList;
	};

  return (
    <div>
      {tablePagos && props.data && (
        <DynamicTable
          data={props.data}
          table={tablePagos}
          actions={tableActions}
          renderPageJump={renderPageJump}
          showPageSizeOptions={true}
          defaultFilterMethod={defaultFilter}
        />
      )}
    </div>
  );

};

export default (withStyles(styles)(ListadoPagos));
